// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1wSAt","title":"Header_title__32R9L","left":"Header_left__1hkM8","clinicName":"Header_clinicName__3v28m"};